import flowapis from "../../api/flow";

import WordTemp from "../WordTemp/index.vue"

export default {
    name: "Template",
    components: {
        WordTemp
      },
    data() {
        return {
            flowList:[],
            flowQuery: {
                keyword: '',
                pageIndex: 1,
                pageSize: 10
            },
            flowVisible:false,
            flowQueryOnce: false,
            query: {
                keyword: "",
                pageIndex: 1,
                pageSize: 10
            },
            flowPageTotal: 0,
            currentTemplateName: '',
            tableCols:[
                {
                    "prop": "Name",
                    "label": "合同模板名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "360",
                    "align": "center"
                }
            ],
            flowCols:[
                {
                    "prop": "Id",
                    "label": "流程编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "Name",
                    "label": "申请人",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "BankName",
                    "label": "银行",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "Money",
                    "label": "金额/万元",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "FinalMoney2",
                    "label": "担保部长确认金额/万元",
                    "align": "center"
                },
                {
                    "prop": "State",
                    "label": "当前节点",
                    "width": "140",
                    "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "最后更新时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "100",
                    "align": "center"
                }
          ],
            tableData:[
                {Name: '反担保保证合同'},
                {Name: '反担保抵押合同'},
                {Name: '委托担保合同'},
                {Name: '委托担保展期合同'},
                {Name: '质押反担保合同'},
                {Name: '最高额保证合同'},
                {Name: '最高额反担保抵押合同'},
                {Name: '最高额质押合同'}
            ]
        };
    },
    beforeCreate: function () {
    },
    created() {
    },
    mounted() {
      let that = this;
    },
    methods: {
        showFlowChoose(name){
            if (!this.flowQueryOnce) {
                this.getFlowList()
            }
            this.flowVisible = true
            this.currentTemplateName = name
        },
        getFlowList(){
            let param=this.flowQuery;
            flowapis.getFlowListCaseWordTemp(param).then(res => {
                this.flowList = res.list;
                if(this.flowList&&this.flowList.length>0){
                    for(let i=0;i<this.flowList.length;i++){
                        if(this.flowList[i].FinalMoney&&this.flowList[i].FinalMoney!==0){
                            this.flowList[i].FinalMoney2 = this.flowList[i].FinalMoney*1.0/1000000
                        }
                    }
                }
                this.flowPageTotal = res.count
                this.flowQueryOnce = true
            });
        },
        handleFlowSizeChange(val) {
            this.flowQuery.pageIndex = 1;
            this.flowQuery.pageSize = val;
            this.getFlowList();
        },
        handleFlowPageChange(val) {
            this.flowQuery.pageIndex = val;
            this.getFlowList();
        },
        chooseFlow(row) {
            let that = this
            if(row){
                this.flowVisible = false
                that.$refs.wordTemp.onChangeOpen(that.currentTemplateName)
                that.$refs.wordTemp.queryData(row)
            }
        }
    },

  };
